import Dexie from 'dexie';
import type { Table } from 'dexie';
import type { LogEntry } from './types';

class LoggingDatabase extends Dexie {
    logs!: Table<LogEntry, number>;

    constructor() {
        super("clientLoggingDb");

        this.version(1).stores({
            logs: "++id, timestamp, level, category, event, sessionId"
        })
    }
}

export const loggingDb = new LoggingDatabase();
